import { createSlice } from '@reduxjs/toolkit';
import { updateTestAction, updateTest2Action } from './stepperActions';
import { StepperState } from './types';

const initialState: StepperState = {
  test: true,
  test2: true,
};

const stepperSlice = createSlice({
  name: 'stepper',
  initialState,
  reducers: {
    updateTest: updateTestAction,
    updateTest2: updateTest2Action,
  },
});

export const { updateTest, updateTest2 } = stepperSlice.actions;

export const stepperReducer = stepperSlice.reducer;
